import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { useIsInSelfServeSplitTest } from '../../../../../customHooks/useIsInSelfServeSplitTest';
import {
    RequirementItem,
    TFundingRequirementStatus
} from '../RequirementsList/RequirementItem/RequirementItem';

type TApplicantCallStepProps = { status: TFundingRequirementStatus };

export const ApplicantCallStep = ({ status }: TApplicantCallStepProps) => {
    const isInSelfServeTest = useIsInSelfServeSplitTest();

    useEffect(() => {
        if (isInSelfServeTest) {
            tracking.ampli.allSetForNowFundingRequirementMessageShown();
        }
    }, [isInSelfServeTest]);

    if (isInSelfServeTest) {
        return (
            <div className="border-b border-secondary-90 p-xl">
                <Text className="text-m font-med text-primary-10">
                    <FormattedMessage
                        id="_.funding_requirements.action_applicant_call_self_serve_title"
                        defaultMessage="You're all set for now"
                    />
                </Text>
                <Text className="mt-xs text-s text-structure-40">
                    <FormattedMessage
                        id="_.funding_requirements.action_applicant_call_self_serve_caption"
                        defaultMessage="We're wrapping up some final checks and will be in touch soon."
                    />
                </Text>
            </div>
        );
    }

    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.applicant_call_step.title"
                    defaultMessage="Give us a quick call"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements.estimated_time"
                    defaultMessage="~ {minutes} mins"
                    values={{ minutes: 5 }}
                />
            }
            href="/funding-requirements/applicant-call"
            status={status}
            completedView={
                <Text className="font-med text-primary-10">
                    <FormattedMessage
                        id="_.funding_requirements.applicant_call_step.title"
                        defaultMessage="Give us a quick call"
                    />
                </Text>
            }
        />
    );
};
